/**
 * O cartão que diz ao operador o que fazer na Home.
 *
 * A decisão de QUANDO falar e O QUE falar não mora aqui: mora em
 * `dominio/orientacaoDaHome.ts`, que é puro e tem teste. Aqui é só o desenho.
 *
 * No estado pronto o componente devolve `null` — a Home volta a ser exatamente
 * a de antes, sem um pixel a mais. É o que mantém o contrato do gabarito nas
 * telas fotografadas dentro do login.
 */
import React from "react";
import { SituacaoDaHome } from "../../../dominio/orientacaoDaHome";
import {
  OrientacaoCartao,
  OrientacaoTexto,
  OrientacaoTitulo,
} from "../styles/Home.styles";

type Props = { situacao: SituacaoDaHome };

const OrientacaoDaHome: React.FC<Props> = ({ situacao }) => {
  if (situacao.chave === "pronto") return null;

  return (
    <OrientacaoCartao
      tom={situacao.tom}
      role="status"
      aria-live="polite"
      // O nome da situação fica no DOM para o gabarito e para o inspetor: dá
      // para conferir em qual estado a tela está sem ler o Zustand.
      data-orientacao={situacao.chave}
    >
      <OrientacaoTitulo tom={situacao.tom}>{situacao.titulo}</OrientacaoTitulo>
      <OrientacaoTexto>{situacao.texto}</OrientacaoTexto>
    </OrientacaoCartao>
  );
};

export default OrientacaoDaHome;
